import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import pet from "../../Assets/fd.png";
import dnk from "../../Assets/dnk.png";
import photo from "../../Assets/Projects/photo.png";
import ph from "../../Assets/movie.png";
import z from "../../Assets/gd.png";
import zb from "../../Assets/byte.png";


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <Col md={6} className="project-card">
            <ProjectCard
              imgPath={pet}
              isBlog={false}
              title="Food Hub"
              description="A (full-stack & responsive) website  designed to enhance user engagement and solve real-world problems, like a recipe-sharing platform with a unique coin-based system and a responsive pet care booking site. "
              ghLink="https://github.com/faisalimroz/food-recipie"
              ghsLink="https://github.com/faisalimroz/food-recipie-server"
              demoLink="https://food-hub-pi.vercel.app/"
            />
          </Col>
          <Col md={6} className="project-card">
            <ProjectCard
              imgPath={z}
              isBlog={false}
              title="Home Crafter"
              description="An online platform designing a multi-vendor platform with distinct roles for admins, providers, and users to integrating secure SSL for seamless service management each project showcases dedication to enhancing functionality. "
              ghLink="https://github.com/faisalimroz/homecraft"
              ghsLink="https://github.com/faisalimroz/homecraft-server"
              demoLink="https://home-crafter.vercel.app/"
            />
          </Col>
       
          <Col md={6} className="project-card">
            <ProjectCard
              imgPath={zb}
              isBlog={false}
              title="ByteonSoft"
              description="A modern, responsive frontend project designed for a company portfolio, ensuring seamless user experience across all devices."
              ghLink="https://github.com/faisalimroz/Byteonsoft"
              ghsLink="https://github.com/faisalimroz/Byteonsoft"
              demoLink="https://byteonsoft.vercel.app/"
            />
          </Col>
          <Col md={6} className="project-card">
            <ProjectCard
              imgPath={photo}
              isBlog={false}
              title="Photogram"
              description="A full-stack and responsive website designed to provide a seamless social media experience. Users can easily create and share posts, view a home page feed with posts from other users, and engage with content through likes and comments."
              ghLink="https://github.com/faisalimroz/photogram"
              ghsLink="https://github.com/faisalimroz/photogram-server"
              demoLink="https://asr-photogram.netlify.app/login"
            />
          </Col>
          <Col md={6} className="project-card">
            <ProjectCard
              imgPath={dnk}
              isBlog={false}
              title="Dnk"
              description="An E-commerce platform for shopping. User can buy products and track the order using dashboard. User can also choose product according to their preference. The website is based on Next.js "
              ghLink="https://github.com/faisalimroz/Next-blog-server/tree/main"
              ghsLink="https://github.com/faisalimroz/DNK-server"
              demoLink="https://dnk-nu.vercel.app/register"
            />
          </Col>
          <Col md={6} className="project-card">
            <ProjectCard
              imgPath={ph}
              isBlog={false}
              title="Movie Hub "
              description="A front-end and responsive website for movies. User can view movie details and search according to theri choice. They can also add movies to the watchlater list"
              ghLink="https://github.com/faisalimroz/movie-hub"
              ghsLink="https://github.com/faisalimroz/movie-hub"
              demoLink="https://movies-hub-dusky.vercel.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
